var sc = sc || {};
sc.alpine = sc.alpine || {};

sc.alpine.submitButton = function () {
    return {
        originalContent: null,
        timeoutId: null,
        button: {
            ['x-on:click']() {
                var el = this.$el;
                this.originalContent = el.innerHTML;
                el.dataset.spinning = true;
                this.timeoutId = setTimeout(function () {
                    el.style.width = el.offsetWidth + 'px';
                    el.style.height = el.offsetHeight + 'px';
                    el.innerHTML = '<div class="flex justify-center w-full"><svg class="animate-spin h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">' +
                        '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
                        '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>' +
                        '</svg></div>';
                }, 400);
                this.$el.style.pointerEvents = 'none'; //disable link
            },
            ['x-on:stop']() {
                clearTimeout(this.timeoutId);
                this.$el.innerHTML = this.originalContent;
                this.$el.style.pointerEvents = 'auto';
                this.$el.style.width = 'auto';
                this.$el.style.height = 'auto';
                this.$el.dataset.spinning = false;
            }
        }
    }
}